module.exports = __webpack_public_path__ + "static/img/3s-platform-img7.b9a0189.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3s-platform-img7.png
// module id = ZiJz
// module chunks = 0